import type {ScheduledBreak} from '../../types/domain'
import {format} from 'date-fns'
function findNumberOfLevelsUntilNextBreak(nextBreak: Pick<ScheduledBreak, 'afterLevelNumber'> | undefined, currentBlindNumberIndex: number) {
  if (nextBreak) {
    return nextBreak.afterLevelNumber - currentBlindNumberIndex -  1
  } else {
    return 0
  }
}
export default function timeUntilNextBreakText(nextBreak: Pick<ScheduledBreak, 'afterLevelNumber'> | undefined, currentBlindNumber: number, levelLengthInMinutes: number, secondsLeftInCurrentSession = levelLengthInMinutes * 60) {
  if (nextBreak) {
    const levelsUntilNextBreak = findNumberOfLevelsUntilNextBreak(nextBreak, currentBlindNumber)
    const secondsUntilBreak = secondsLeftInCurrentSession + levelsUntilNextBreak * levelLengthInMinutes * 60
    const now = new Date()
    now.setSeconds(now.getSeconds() + secondsUntilBreak)

    return format(now, 'h:mmaaa')
  }
  return 'N/A'
}
